<template>
  <div class="sidebar-container">
    <button
      v-if="mobileMenuOpen"
      type="button"
      class="hemolife-menu-backdrop"
      aria-label="Cerrar menú y volver al contenido"
      tabindex="-1"
      @click="closeMobileMenu(true)"
    ></button>
    <aside id="hemolife-main-menu" ref="sidebar" class="main-sidebar sidebar-light-danger elevation-2 hemolife-sidebar">
      <button type="button" class="hemolife-menu-close" aria-label="Cerrar menú" @click="closeMobileMenu(true)">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
      <router-link to="/" class="brand-link hemolife-brand-link" aria-label="Ir al inicio" @click.native="closeMobileMenu()">
        <img :src="logoUrl" alt="Logo de la organización" class="hemolife-brand-logo" />
        <span class="hemolife-brand-subtitle">Fundación Banco Nacional de Sangre</span>
      </router-link>

      <div class="sidebar hemolife-sidebar-body">
        <form class="hemolife-menu-search" role="search" @submit.prevent>
          <i class="fas fa-search" aria-hidden="true"></i>
          <input
            v-model="filtro"
            type="search"
            placeholder="Buscar en menú…"
            aria-label="Buscar en menú"
          />
        </form>

        <nav class="hemolife-menu" aria-label="Menú principal">
          <ul class="nav nav-pills nav-sidebar flex-column">
            <li v-for="menu in filterMenu" :key="menu.id" class="nav-item">
              <button
                type="button"
                class="nav-link hemolife-menu-group"
                :class="{ 'is-current': isActiveMenu(menu) }"
                :title="menu.nombre"
                :aria-label="menu.nombre"
                :aria-expanded="isMenuOpen(menu) ? 'true' : 'false'"
                :aria-controls="'hemolife-menu-' + menu.id"
                @click="toggleMenu(menu)"
              >
                <i class="nav-icon" :class="menu.icono" aria-hidden="true"></i>
                <span class="hemolife-menu-label">{{ menu.nombre }}</span>
                <i
                  class="fas fa-chevron-right hemolife-menu-chevron"
                  :class="{ 'is-open': isMenuOpen(menu) }"
                  aria-hidden="true"
                ></i>
              </button>
              <ul
                :id="'hemolife-menu-' + menu.id"
                v-show="isMenuOpen(menu)"
                class="nav nav-treeview hemolife-submenu"
              >
                <li v-for="nivel2 in menu.nivel2" :key="nivel2.id" class="nav-item">
                  <router-link
                    :to="nivel2.ruta"
                    class="nav-link"
                    :class="{ active: isActiveRoute(nivel2.ruta) }"
                    :aria-current="isActiveRoute(nivel2.ruta) ? 'page' : null"
                    :title="nivel2.nombre"
                    @click.native="closeMobileMenu()"
                  >
                    <i class="nav-icon" :class="nivel2.icono" aria-hidden="true"></i>
                    <span class="hemolife-menu-label">{{ nivel2.nombre }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
          <p v-if="filtro && !filterMenu.length" class="hemolife-menu-empty" role="status">
            No hay opciones para esta búsqueda.
          </p>
        </nav>
      </div>

      <div class="hemolife-sidebar-footer">
        <a href="https://hemolifeamerica.org/" target="_blank" rel="noopener noreferrer">
          <img :src="logoUrl" alt="Sitio web de la organización" />
        </a>
      </div>
    </aside>
  </div>
</template>

<script>
import clienteLogo from "../../services/clienteLogo";
import attachMobileMenu from "../../services/mobileMenu";

export default {
  name: "NavBarLeft",
  data() {
    return { filtro: "", expandedMenus: {}, mobileMenuOpen: false };
  },
  computed: {
    logoUrl() {
      return clienteLogo(this.$store.getters.getUser);
    },
    filterMenu() {
      const search = this.filtro.trim().toLocaleLowerCase("es");
      return (this.$store.state.menus || [])
        .map((menu) => {
          const matchesGroup = menu.nombre.toLocaleLowerCase("es").includes(search);
          const nivel2 = (menu.nivel2 || []).filter(
            (item) => matchesGroup || item.nombre.toLocaleLowerCase("es").includes(search)
          );
          return nivel2.length ? { ...menu, nivel2 } : null;
        })
        .filter(Boolean);
    },
  },
  watch: {
    "$route.path"() {
      this.closeMobileMenu();
      (this.$store.state.menus || []).forEach((menu) => {
        if (this.isActiveMenu(menu)) this.$set(this.expandedMenus, menu.id, true);
      });
    },
  },
  methods: {
    closeMobileMenu(restoreFocus = false) {
      if (this.mobileMenuController) this.mobileMenuController.close(restoreFocus);
    },
    isActiveRoute(route) {
      // Query/hash no deben desmarcar la opción actual.
      return this.$route.path === String(route || "").split(/[?#]/)[0];
    },
    isActiveMenu(menu) {
      return (menu.nivel2 || []).some((item) => this.isActiveRoute(item.ruta));
    },
    isMenuOpen(menu) {
      if (this.filtro.trim()) return true;
      if (Object.prototype.hasOwnProperty.call(this.expandedMenus, menu.id)) {
        return this.expandedMenus[menu.id];
      }
      return this.isActiveMenu(menu);
    },
    toggleMenu(menu) {
      this.$set(this.expandedMenus, menu.id, !this.isMenuOpen(menu));
    },
  },
  mounted() {
    this.mobileMenuController = attachMobileMenu(this.$refs.sidebar, (open) => {
      this.mobileMenuOpen = open;
    });
  },
  beforeDestroy() {
    if (this.mobileMenuController) this.mobileMenuController.destroy();
  },
};
</script>

<style>
/* Todo el layout queda limitado a este menú: no modifica las otras vistas. */
.hemolife-sidebar.main-sidebar {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  border-right: 1px solid #e5eaf1;
  background: #fdfefe;
  box-shadow: 2px 0 18px rgba(15, 23, 42, 0.06);
}
.hemolife-menu-close,
.hemolife-menu-backdrop {
  display: none;
}
.hemolife-sidebar .hemolife-brand-link {
  display: flex;
  flex: 0 0 112px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  border-bottom: 1px solid #e5eaf1;
  white-space: normal;
}
.hemolife-sidebar .hemolife-brand-logo {
  width: 132px;
  height: 48px;
  object-fit: contain;
}
.hemolife-sidebar .hemolife-brand-subtitle {
  max-width: 212px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.3;
  text-align: center;
}
.hemolife-sidebar .hemolife-sidebar-body {
  flex: 1 1 auto;
  min-height: 0;
  height: auto !important;
  max-height: none;
  padding: 12px 8px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
}
.hemolife-sidebar .hemolife-menu-search {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 38px;
  margin: 0 4px 14px;
  padding: 0 12px;
  border: 1px solid #dfe7f2;
  border-radius: 8px;
  background: #f5f7fb;
  color: #64748b;
}
.hemolife-sidebar .hemolife-menu-search:focus-within {
  border-color: #4e6990;
  box-shadow: 0 0 0 2px rgba(78, 105, 144, 0.12);
}
.hemolife-sidebar .hemolife-menu-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #334155;
  font-size: 13px;
}
.hemolife-sidebar .nav-sidebar,
.hemolife-sidebar .nav-sidebar .nav-item {
  width: 100%;
}
.hemolife-sidebar .nav-sidebar .nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100% !important;
  min-height: 42px;
  margin: 2px 0;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #475569;
  font-size: 14px;
  line-height: 1.3;
  text-align: left;
  white-space: normal;
}
.hemolife-sidebar .nav-sidebar .nav-link:hover {
  background: #f0f4fa;
  color: #243e61;
}
.hemolife-sidebar .nav-sidebar .nav-link:focus-visible {
  outline: 2px solid #4e6990;
  outline-offset: -2px;
}
.hemolife-sidebar .nav-sidebar .nav-icon {
  flex: 0 0 20px;
  width: 20px;
  margin: 0 !important;
  font-size: 16px;
  text-align: center;
}
.hemolife-sidebar .hemolife-menu-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}
.hemolife-sidebar .hemolife-menu-group {
  font-weight: 600;
  cursor: pointer;
}
.hemolife-sidebar .hemolife-menu-group.is-current {
  background: #eef3fa;
  color: #314e73;
}
.hemolife-sidebar .hemolife-menu-chevron {
  flex: 0 0 12px;
  font-size: 10px;
  transition: transform 0.15s ease;
}
.hemolife-sidebar .hemolife-menu-chevron.is-open {
  transform: rotate(90deg);
}
.hemolife-sidebar .hemolife-submenu {
  /* Vue controla apertura; no mezclar v-show con el treeview de jQuery. */
  display: block;
  padding: 2px 0 6px 16px;
}
.hemolife-sidebar .hemolife-submenu .nav-link {
  min-height: 38px;
  padding: 8px 12px;
  font-size: 13px;
}
.hemolife-sidebar .hemolife-submenu .nav-link.active {
  background: #fff0f1 !important;
  color: #a5212a !important;
  box-shadow: inset 3px 0 #e53538;
  font-weight: 600;
}
.hemolife-sidebar .hemolife-sidebar-footer {
  flex: 0 0 auto;
  padding: 12px;
  border-top: 1px solid #e5eaf1;
  text-align: center;
}
.hemolife-sidebar .hemolife-sidebar-footer img {
  width: 76px;
  height: 30px;
  object-fit: contain;
  opacity: 0.8;
}
.hemolife-sidebar .hemolife-menu-empty {
  padding: 12px;
  color: #64748b;
  font-size: 13px;
}
/* Rail compacto: solo iconos de grupo, sin buscador/submenús que se desborden.
   Hover y foco recuperan el menú completo sin mover el contenido de la página. */
@media (min-width: 992px) {
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-brand-logo {
    width: 40px;
    height: 40px;
  }
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-brand-subtitle,
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-menu-search,
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-menu-label,
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-menu-chevron,
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-submenu,
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-sidebar-footer {
    display: none !important;
  }
  body.sidebar-collapse .hemolife-sidebar:not(:hover):not(:focus-within):not(.sidebar-focused) .hemolife-menu-group {
    justify-content: center;
    padding: 10px 0;
  }
  body.sidebar-collapse .hemolife-sidebar:hover,
  body.sidebar-collapse .hemolife-sidebar:focus-within,
  body.sidebar-collapse .hemolife-sidebar.sidebar-focused {
    width: 250px;
  }
}
@media (max-width: 991.98px) {
  body.sidebar-mini-xs .hemolife-sidebar {
    width: min(280px, calc(100vw - 48px)) !important;
    position: fixed;
    margin-left: 0 !important;
    z-index: 1041;
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
  body.sidebar-mini-xs:not(.sidebar-open) .hemolife-sidebar {
    transform: translateX(-100%);
    visibility: hidden;
    pointer-events: none;
  }
  body.sidebar-mini-xs.sidebar-open .hemolife-sidebar {
    margin-left: 0;
    transform: translateX(0);
    visibility: visible;
    pointer-events: auto;
  }
  .hemolife-sidebar .hemolife-brand-link {
    flex-basis: 92px;
    padding: 8px 40px;
    gap: 4px;
  }
  .hemolife-sidebar .hemolife-brand-subtitle {
    font-size: 11px;
  }
  .hemolife-sidebar .hemolife-sidebar-footer {
    display: none;
  }
  .hemolife-sidebar .hemolife-sidebar-body {
    -webkit-overflow-scrolling: touch;
    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px));
  }
  .hemolife-sidebar .hemolife-menu-search {
    height: 44px;
  }
  .hemolife-sidebar .hemolife-menu-search input {
    /* Safari no amplía la página al enfocar el buscador. */
    font-size: 16px;
  }
  .hemolife-sidebar .nav-sidebar .nav-link {
    min-height: 44px;
  }
  .hemolife-menu-close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: max(8px, env(safe-area-inset-top, 0px));
    right: 8px;
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 8px;
    background: #eef3fa;
    color: #314e73;
    cursor: pointer;
  }
  .hemolife-menu-close:focus-visible {
    outline: 2px solid #4e6990;
  }
  .hemolife-menu-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    background: rgba(15, 23, 42, 0.48);
    z-index: 1040;
    cursor: pointer;
  }
  body.hemolife-mobile-menu-open {
    overflow: hidden;
  }
  body.hemolife-mobile-menu-open .main-header,
  body.hemolife-mobile-menu-open .content-wrapper,
  body.hemolife-mobile-menu-open .main-footer {
    pointer-events: none;
  }
  /* Vue conserva el fondo aun si el plugin lo agregó a una vista desmontada. */
  body.sidebar-mini-xs #sidebar-overlay {
    display: none !important;
  }
  body.sidebar-mini-xs .main-header,
  body.sidebar-mini-xs .content-wrapper,
  body.sidebar-mini-xs .main-footer,
  body.sidebar-mini-xs.sidebar-collapse .main-header,
  body.sidebar-mini-xs.sidebar-collapse .content-wrapper,
  body.sidebar-mini-xs.sidebar-collapse .main-footer {
    margin-left: 0 !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .hemolife-sidebar .hemolife-menu-chevron {
    transition: none;
  }
}
</style>
